import { Box, Typography } from '@mui/material';
import React from 'react';

import { EmptyPanelIllustration } from './illustrations/EmptyPanel';
import { ErrorLoadingIllustration } from './illustrations/ErrorLoading';
import { NAV_COLOR_PALETTE } from './styleConstants';

interface IIllustratedMessageProps {
  dataTest: string;
  headerText?: string;
  messageText?: string;
  illustrationHeight?: number;
  illustrationWidth?: number;
  mobileWidth?: boolean;
  illustrationType: 'error-loading' | 'empty-panel';
}

export const IllustratedMessage: React.FC<IIllustratedMessageProps> = ({
  dataTest,
  headerText,
  messageText,
  illustrationType,
  illustrationHeight,
  illustrationWidth,
  mobileWidth
}: IIllustratedMessageProps) => {
  return (
    <Box
      data-test={dataTest}
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: 1
      }}
    >
      <Box>
        {illustrationType === 'empty-panel' && (
          <EmptyPanelIllustration
            dataTest={`${dataTest}Illustration`}
            height={illustrationHeight}
            width={illustrationWidth}
          />
        )}
        {illustrationType === 'error-loading' && (
          <ErrorLoadingIllustration
            dataTest={`${dataTest}Illustration`}
            height={illustrationHeight}
            width={illustrationWidth}
          />
        )}
      </Box>
      <Typography sx={{ color: NAV_COLOR_PALETTE.primaryGray }}>{headerText}</Typography>
      <Typography
        variant={mobileWidth ? 'caption' : 'bodySmall'}
        sx={{ color: NAV_COLOR_PALETTE.secondaryGray, textAlign: 'center' }}
      >
        {messageText}
      </Typography>
    </Box>
  );
};
